import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { flowRight as compose } from "lodash";
import { withStore } from "../../store";
import { Button } from "@brightcove/studio-components";
import ExternalLink from "../ExternalLink/ExternalLink";
import { SVGImage } from "../../assets/images";
import "./SlideInfo.scss";
import { metUrl } from "../../config/metMainSite";

class SlideInfo extends React.Component<any, any> {
  showLogIn = () => {
    this.props.showLogIn();
  };

  openLearnMore = () => {
    window.location = metUrl("/season/on-demand/learn-more");
  };

  render() {
    const {
      header,
      subHeader,
      url,
      ctaLabel,
      mediaType,
      fixed,
      description,
      store: { user },
    } = this.props;
    return (
      <div className={`slide-overlay-info-wrapper ${fixed ? "fixed" : ""}`}>
        <div className="slide-overlay-info">
          {!user && (
            <div className="login-ctas">
              <Button
                theme="classic"
                className="btn btn-pink"
                onClick={this.openLearnMore}
              >
                Start free 7-day trial
              </Button>
              <Button
                theme="classic"
                className="btn btn-transparent white"
                onClick={this.showLogIn}
              >
                Login
              </Button>
              <ExternalLink
                url={metUrl("/season/on-demand/gift-subscriptions/")}
                text="Give/Redeem Gift Subscription"
              />
            </div>
          )}
          <div className="metadata">
            {subHeader && (
              <h3
                className="subheader"
                dangerouslySetInnerHTML={{ __html: subHeader }}
              />
            )}
            <h2 className="header">
              <i>
                <span dangerouslySetInnerHTML={{ __html: header }} />
              </i>
            </h2>
            { mediaType &&
            <NavLink to={url} className="watch-now" exact>
              {/* MET2-2874: play icon is decorative — aria-hidden + empty alt */}
              <span className="play-icon-wrapper" aria-hidden="true">
                <img
                  src={SVGImage.PlayIcon}
                  alt=""
                  className="play-icon"
                />
              </span>
              {ctaLabel || ((mediaType === "audio" || mediaType === "audio_stream") ? "Listen Now" : "Watch Now")}
              {/* MET2-2874: append opera title for screen readers so links are distinguishable */}
              {header && <span className="sr-only"> – <span dangerouslySetInnerHTML={{ __html: header }} /></span>}
            </NavLink>
            }
            {
              !mediaType &&  <div className="description" dangerouslySetInnerHTML={{ __html: description }}></div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default compose(withRouter, withStore)(SlideInfo);
